<template>
  <div>
    <!-- Banner Area -->
    <section id="common_banner_one">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="common_banner_text">
              <h2>Gift List</h2>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Gift List Area -->
    <section id="wedding_list_area" class="ptb-100">
      <div class="container">
        <div v-if="weddingList" class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="card-body">
                <h3>
                  {{
                    weddingList.user
                      ? weddingList.user.first_name +
                        " " +
                        weddingList.user.last_name +
                        "'s Gift List"
                      : weddingList.title
                  }}
                </h3>
                <p v-if="weddingList.wedding_date">
                  Wedding Date: {{ formatDate(weddingList.wedding_date) }}
                </p>
              </div>
            </div>
          </div>

          <!-- Items List -->
          <div class="col-12">
            <div class="row">
              <div
                v-for="item in weddingList.items"
                :key="item.id"
                class="col-md-4 mb-4"
              >
                <div class="card">
                  <div class="card-body">
                    <router-link
                      :to="{ path: '/product/' + item.product.id }"
                      class="offcanvas-wishlist-item-image-link"
                    >
                      <img
                        :src="item.product.image"
                        alt="img"
                        class="offcanvas-wishlist-image"
                      />
                    </router-link>
                    <h5 class="mt-3 mb-1">
                      <router-link
                        class="fw-600 color-gray"
                        :to="{ path: '/product/' + item.product.id }"
                        >{{ item.product.name }}</router-link
                      >
                    </h5>
                    <p class="mb-1">Quantity: {{ item.quantity }}</p>
                    <p class="mb-1">
                      Price:
                      {{
                        $country == "eg"
                          ? (item.product.discount_price_egp > 0
                              ? item.product.discount_price_egp
                              : item.product.price_egp) + " EGP"
                          : "$" +
                            (item.product.discount_price_usd > 0
                              ? item.product.discount_price_usd
                              : item.product.price_usd)
                      }}
                    </p>
                    <p class="mb-3">Status: {{ item.status }}</p>
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <button
                        class="btn theme-btn-one bg-light"
                        :disabled="item.status !== 'available'"
                        @click="reserveItem(item.id)"
                        v-if="item.status !== 'purchased'"
                      >
                        {{
                          item.status === "available"
                            ? "Reserve Item"
                            : "Reserved"
                        }}
                      </button>
                      <button
                        class="btn theme-btn-one bg-black"
                        @click="buyProduct(item)"
                        v-if="item.status === 'reserved'"
                      >
                        Buy Item as Gift
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!submitted && !weddingList" class="text-center">
          <p>Loading Gift List...</p>
        </div>

        <div v-else-if="submitted && !weddingList" class="text-center">
          <p>Your Gift List is Empty</p>
        </div>
      </div>
    </section>

    <!-- Product Modal -->
    <div class="modal fade" id="productModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              {{ selectedProduct ? selectedProduct.name : "" }}
            </h5>
            <button type="button" class="close" data-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="selectedProduct">
            <div class="row">
              <div class="col-md-6">
                <img
                  :src="selectedProduct.image"
                  class="img-fluid"
                  :alt="selectedProduct.name"
                />
              </div>
              <div class="col-md-6">
                <h4>{{ selectedProduct.name }}</h4>
                <p>{{ selectedProduct.description }}</p>
                <p class="price">Price: ${{ selectedProduct.price }}</p>
                <button class="btn btn-primary" @click="goToProduct">
                  View on Website
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from "../Auth";
export default {
  name: "SharedWeddingList",
  data() {
    return {
      weddingList: null,
      selectedProduct: null,
      submitted: false,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.fetchWeddingList();
  },
  methods: {
    async fetchWeddingList() {
      try {
        const shareCode = this.$route.params.shareCode;
        const response = await this.$http.get(
          `/wedding-list/${shareCode}`,
          "",
          true,
        );
        this.weddingList = response.data.data;
        this.submitted = true;
      } catch (error) {
        console.error("Error fetching gift list:", error);
      }
    },
    async reserveItem(itemId) {
      try {
        if (!Auth.authenticated()) {
          this.$swal
            .fire({
              title: "Please login to reserve or buy gift list items",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Login",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#6d6f71",
              cancelButtonColor: "#d33",
            })
            .then((result) => {
              if (result.isConfirmed) {
                this.$router.push("/login");
              }
            });
          return;
        }
        const shareCode = this.$route.params.shareCode;
        await this.$http.post(
          `/wedding-list/${shareCode}/items/${itemId}/reserve`,
          "",
          true,
        );
        this.fetchWeddingList();

        this.$store.dispatch("alert/success", "Item reserved successfully");
      } catch (error) {
        console.error("Error reserving item:", error);
        this.$store.dispatch(
          "alert/error",
          "Error reserving item. Please try again.",
        );
      }
    },
    buyProduct(item) {
      this.selectedProduct = item.product;
      this.$router.push(
        "/product/" + item.product.id + "?shared=true&shareId=" + item.id,
      );
    },
    goToProduct() {
      window.location.href = `/product/${this.selectedProduct.id}`;
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString();
    },
  },
};
</script>

<style scoped>
.card {
  border: 1px solid #ddd;
  border-radius: 4px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.offcanvas-wishlist-item-image-link {
  display: block;
  width: 100%;
}

.offcanvas-wishlist-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 4px;
}

.price {
  font-size: 1.2em;
  font-weight: bold;
  color: #28a745;
}

.d-flex.justify-content-between {
  margin-top: auto;
}
</style>
